export default function FileIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.25 1H5.25C4.65326 1 4.08097 1.23178 3.65901 1.64437C3.23705 2.05695 3 2.61652 3 3.2V20.8C3 21.3835 3.23705 21.9431 3.65901 22.3556C4.08097 22.7682 4.65326 23 5.25 23H18.75C19.3467 23 19.919 22.7682 20.341 22.3556C20.7629 21.9431 21 21.3835 21 20.8V6.6L14.25 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 1V7H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 14H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 18H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 10H9.5H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
